export type BrokerLeadOffer = "BROKER_CONSULTATION" | "FREE_VALUATION";
export function brokerLeadOffer(value: unknown): BrokerLeadOffer {
  return value === "FREE_VALUATION" ? "FREE_VALUATION" : "BROKER_CONSULTATION";
}
/** The estimate form is English-only; bilingual campaigns retain Spanish intake. */
export function brokerLeadOfferForLanguage(
  value: unknown,
  language?: string,
): BrokerLeadOffer {
  return language === "es" ? "BROKER_CONSULTATION" : brokerLeadOffer(value);
}
export function brokerLeadOfferInstruction(offer: BrokerLeadOffer) {
  return offer === "FREE_VALUATION"
    ? "Offer a free business value estimate after a few questions and contact details. EVERY primary text and headline, including alternates, must explicitly name the estimate; generic sale or consultation copy is insufficient. Use a clear invitation such as ‘Get a free business value estimate’. Explain that it is an estimate, not a professional valuation, and that the broker can review their financials and discuss next steps. Never promise an instant result, certified appraisal, exact sale price, or guaranteed value. Use LEARN_MORE or CONTACT_US."
    : "The offer is a confidential broker consultation after a short questionnaire. Never offer a valuation, appraisal, or instant estimate. Use LEARN_MORE or CONTACT_US.";
}
